export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyAGU7DvL_V1BBNcE5L-MsOpcZJw4URkxD8",
    // Use the custom domain that serves the app as the authDomain so the
    // signInWithRedirect auth iframe shares an origin with the app. This
    // avoids the cross-origin third-party storage that Chrome M115+, Firefox
    // 109+ and Safari 16.1+ block (which made getRedirectResult return null).
    // See: https://firebase.google.com/docs/auth/web/redirect-best-practices
    authDomain: "stepup90.com",
    databaseURL: "https://healing-our-villages.firebaseio.com",
    projectId: "healing-our-villages",
    storageBucket: "healing-our-villages.appspot.com",
    messagingSenderId: "51653682994",
    appId: "1:51653682994:web:aecfb913d76cf7bbc2992b",
    measurementId: "G-CLMFLXGVJY"
  }
};
